export default "__VITE_ASSET__PnbN4Esn__"